var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mt-6 mb-4 text-base"},[_vm._v("\n    Funding Used\n  ")]),_vm._v(" "),_c('pie-chart',{attrs:{"chart-data":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }